import { SET_SOURCE_DEBUGGER_SETTINGS } from 'actions'
import createSettingsReducer from '../utils/create-settings-reducer'

export default createSettingsReducer(SET_SOURCE_DEBUGGER_SETTINGS, {
  selectedEvent: null,
  selectedTestConnectionDestination: null,
  searchTerm: '',
  activeDetailTab: 'pretty',
  isFiltersOpen: false,
  isTestConnectionDialogShown: false,
  isTestConnectionNoticeShown: true,
  keyword: '',
  keywords: [],
  searchFullMessage: false,
  filters: {
    allowed: true,
    blocked: true,
    violations: true,
    track: true,
    page: true,
    screen: true,
    identify: true,
    group: true,
    alias: true,
    events: true,
    objects: true
  }
})
